import React, { Component } from "react";
import Modal from "react-modal";
import { connect } from "react-redux";

import {
  addSigDoc,
  select_doc,
  buscaDocumento,
  limpa_msgs,
  showInfoSignatario,
  contatarSignatario,
  getTypesSig,
} from "../../actions";
import { validaCPF, removeSpecialCharacters } from "../../utils/Utils";
import InputMask from "react-input-mask";
import { detectar_mobile } from "../../utils/Utils";

const INITIAL_SIGNATARIO = {
  tipoAss: "",
  tipoAut: "email",
  mensagem: "",
  nome: "",
  cpfCnpj: "",
  email: "",
  dataNasc: "",
  celular: "",
  selfieNecessaria: "S",
  realizarValidacaoFacial: "N",
};

class ModalSignatario extends Component {
  constructor() {
    super();
    this.state = {
      modalIsOpen: true,
      signatario: { ...INITIAL_SIGNATARIO },
    };

    this.inputChange = this.inputChange.bind(this);
    this.formSubmit = this.formSubmit.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.props.getTypesSig();
  }

  inputChange(event) {
    var { signatario } = this.state;
    let name = event.target.name;
    let value = event.target.value;
    signatario[name] = value;
    this.setState({ signatario });
  }

  formSubmit(event) {
    event.preventDefault();
    const { documento } = this.props.documentos;
    var { signatario } = this.state;
    var { selfieNecessaria, celular, email, tipoAut, cpfCnpj } = signatario;

    cpfCnpj = removeSpecialCharacters(cpfCnpj);
    celular = removeSpecialCharacters(celular);

    for (let i in signatario) {
      if (
        (i != "mensagem" &&
          i != "dataNasc" &&
          signatario[i].trim() == "" &&
          i != "email" &&
          i != "celular") ||
        (selfieNecessaria != "S" && i == "email" && signatario[i].trim() == "")
      )
        return alert("preencha o campo " + i);
    }

    if (!validaCPF(cpfCnpj)) return alert("CPF inválido!");

    // if (signatario.selfieNecessaria === 'S') {
    //     signatario.tipoAut = 'sms'
    // } else {
    //     signatario.tipoAut = 'email'
    // }

    this.props.addSigDoc(documento, signatario, async (err) => {
      if (!err) {
        await this.setState({ signatario: { ...INITIAL_SIGNATARIO } });
        try {
          await Array.from(
            document.querySelectorAll("form#cadastroSig input")
          ).map((input) => (input.value = ""));
          document.querySelector("select[name=tipoAut]").value = "sms";
          document.querySelector("select[name=selfieNecessaria]").value = "S";
          document.querySelector("select[name=tipoAss]").value = "";
          document.querySelector("form#cadastroSig textarea").value = "";
        } catch (error) {
          console.log("ERROR", error);
        }

        this.props.buscaDocumento(documento.id, (res) => {
          if (res) {
            const novoDocumento = this.props.documentos.documento;
            const { signatarios } = novoDocumento;
            const id_sig = signatarios[signatarios.length - 1].id;
            //this.props.enviarEmailSig(documento.id, id_sig)
            this.forceUpdate();
          }
        });
        this.props.limpa_msgs();
        document.querySelector("#modalSignatario .close").click();
      }
    });
  }

  closeModal() {
    this.props.closeModal();
  }

  modalAdd() {
    const { documento, sig_load, sig_msg, sig_error } = this.props.documentos;
    const { tiposSignatarios, load_signatario } = this.props.signatario;
    const {
      email,
      celular,
      nome,
      dataNasc,
      mensagem,
      cpfCnpj,
      selfieNecessaria,
      realizarValidacaoFacial,
    } = this.state.signatario;
    const {
      serproValidacaoFacial,
      serproValorValidacaoFacial,
      admin,
      gerente,
    } = this.props.auth.user;

    const { isDocumentoGerenciado, isManipulaDocumento } = documento;

    const isAdmin = admin;
    const isGerente = gerente;
    const docFinalizado =
      (documento.status || "").toLowerCase().search(/assinado|finalizado/gi) >
        -1 || (documento.status || "").toLowerCase().includes("cancelado");

    const permissaoManipulacaoGerencial =
      !docFinalizado &&
      ((isDocumentoGerenciado && isManipulaDocumento) ||
        (isGerente && isManipulaDocumento) ||
        isAdmin);

    return (
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              Adicionar signatário
            </h5>
            <button type="button" className="close" data-dismiss="modal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body text-center">
            <form id="cadastroSig" onSubmit={this.formSubmit}>
              <div className="row">
                <div className="col col-sm-12 col-md-12 col-lg-5">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Contato do signatário</h5>
                      <p className="card-text"></p>
                      {/* <!-- email --> */}
                      <div className="form-group">
                        <label>E-mail</label>
                        <input
                          type="email"
                          className="form-control"
                          name="email"
                          value={email}
                          onChange={this.inputChange}
                          aria-describedby="emailHelp"
                          placeholder="Ex: joaodasilva@gmail.com"
                          required={selfieNecessaria !== "S"}
                        />
                        <small id="emailHelp" className="form-text text-muted">
                          Não compartilhamos esse e-mail com ninguém
                        </small>
                      </div>

                      <div className="form-group">
                        <label>Celular</label>
                        {/* <input value={celular} type="tel" className="form-control" name="celular"
                                                        maxLength="11" onChange={this.inputChange} aria-describedby="celularHelp" placeholder="Ex: (99) 99999-9999" required={selfieNecessaria === 'S'}/> */}
                        <InputMask
                          value={celular}
                          type="tel"
                          className="form-control"
                          name="celular"
                          onChange={this.inputChange}
                          aria-describedby="celularHelp"
                          placeholder="Ex: (99) 99999-9999"
                          required={selfieNecessaria === "S"}
                          mask="(99) 99999-9999"
                        />
                        <small
                          id="celularHelp"
                          className="form-text text-muted"
                        >
                          Não compartilhamos esse celular com ninguém
                        </small>
                      </div>

                      <div className="form-group">
                        <label>Confirmar assinatura com selfie?</label>
                        <select
                          className="form-control"
                          name="selfieNecessaria"
                          onChange={this.inputChange}
                          required
                          defaultValue="S"
                        >
                          <option value="S">Sim</option>
                          <option value="N">Não</option>
                        </select>
                      </div>

                      {selfieNecessaria === "S" && serproValidacaoFacial && (
                        <div className="form-group">
                          <label>
                            Validar selfie com biometria facial (SERPRO)?
                          </label>
                          <select
                            className="form-control"
                            name="realizarValidacaoFacial"
                            onChange={this.inputChange}
                            required
                            defaultValue="N"
                            value={realizarValidacaoFacial}
                          >
                            <option value="S">Sim</option>
                            <option value="N">Não</option>
                          </select>
                          {selfieNecessaria === "S" &&
                            realizarValidacaoFacial === "S" && (
                              <span style={{ color: "red" }}>
                                {`* Será cobrado um valor adicional de`} <br />{" "}
                                {`${serproValorValidacaoFacial} por verificação.`}
                              </span>
                            )}
                        </div>
                      )}

                      <div className="form-group">
                        <label>Autenticação usando</label>
                        <select
                          className="form-control"
                          name="tipoAut"
                          onChange={this.inputChange}
                          required
                        >
                          <option value="email">E-mail</option>
                          <option value="sms">SMS</option>
                          {permissaoManipulacaoGerencial && (
                            <option value="whatsapp">WhatsApp</option>
                          )}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col col-sm-12 col-md-12 col-lg-7">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Dados do signatário</h5>
                      <p className="card-text"></p>

                      <div className="form-group">
                        <label>Nome Completo</label>
                        <input
                          value={nome}
                          type="text"
                          className="form-control"
                          name="nome"
                          onChange={this.inputChange}
                          aria-describedby="emailHelp"
                          placeholder="Ex: João da Silva"
                          required
                        />
                      </div>

                      <div className="form-group">
                        <label>CPF</label>
                        {/* <input value={cpfCnpj} onChange={this.inputChange} maxLength="11" type="text" className="form-control" name="cpfCnpj" placeholder="Ex: 123.456.789-12" required /> */}
                        <InputMask
                          mask="999.999.999-99"
                          value={cpfCnpj}
                          onChange={this.inputChange}
                          type="text"
                          className="form-control"
                          name="cpfCnpj"
                          placeholder="Ex: 123.456.789-12"
                          required
                        />
                      </div>

                      <div className="form-group">
                        <label>Data de nascimento</label>
                        {/* <input value={dataNasc} type="date" className="form-control" name="dataNasc"
                                                    onChange={this.inputChange} placeholder="Ex: 01/01/1999"  /> */}
                        <InputMask
                          value={dataNasc}
                          type="date"
                          className="form-control"
                          name="dataNasc"
                          onChange={this.inputChange}
                          placeholder="Ex: 01/01/1999"
                        />
                      </div>

                      <div className="form-group">
                        <label>Assinar como</label>
                        {!load_signatario ? (
                          <select
                            className="form-control"
                            name="tipoAss"
                            onChange={this.inputChange}
                            required
                          >
                            <option value={"selecione"} selected>
                              --
                            </option>
                            {tiposSignatarios &&
                              tiposSignatarios.map((tipo) => (
                                <option key={tipo} value={tipo}>
                                  {tipo}
                                </option>
                              ))}
                          </select>
                        ) : (
                          <div
                            className="spinner-border"
                            role="status"
                            style={{ margin: "5%" }}
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        )}
                      </div>

                      <div className="form-group">
                        <label>Mensagem (Opcional)</label>
                        <textarea
                          value={mensagem}
                          onChange={this.inputChange}
                          className="form-control"
                          name="mensagem"
                          rows="3"
                        ></textarea>
                      </div>

                      {sig_load ? (
                        <div
                          className="spinner-border"
                          role="status"
                          style={{ margin: "5%" }}
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : (
                        <button type="submit" className="btn btn-primary">
                          Adicionar Signatário
                        </button>
                      )}

                      {sig_msg != "" ? (
                        <div
                          className={`alert alert-${
                            sig_error ? "warning" : "success"
                          } `}
                          role="alert"
                        >
                          {sig_msg}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <style>
          {`
                        #cadastroSig input::placeholder { 
                            color: #c6c9cc;
                            opacity: 1; 
                        }
                        
                        #cadastroSig input:-ms-input-placeholder { 
                            color: #c6c9cc;
                        }
                        
                        #cadastroSig input::-ms-input-placeholder {
                            color: #c6c9cc;
                        }
                    `}
        </style>
      </div>
    );
  }

  modalRm() {
    return (
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              Remover Signatário
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body text-center">
            <img
              className="mb-4 "
              src="assets/imagem/cancelado.png"
              alt=""
              width="100"
              height="100"
            />

            <h4>Gostaria de remover o signatário?</h4>
            <small>As assinaturas já efetuadas serão inválidadas</small>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-danger"
              data-dismiss="modal"
              onClick={() => this.props.removeSigDoc()}
            >
              Remover
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    );
  }

  modalInfos() {
    const { nome, cpfCnpj, email, dataNasc, celular, pivot } =
      this.props.signatario.infos || {};
    const {
      status,
      tipo,
      assinado_em,
      mensagem,
      selfieNecessaria,
      tipoNotificacao,
      realizarValidacaoFacial,
    } = pivot || {};
    const tipoStyle =
      (status || "").toLowerCase().search(/assinado|finalizado/gi) > -1
        ? "success"
        : "warning";
    const styleInfo = detectar_mobile() ? {} : { width: "30%" };
    return (
      <div
        className="modal-dialog modal-lg"
        role="document"
        style={{ ...styleInfo }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              Informações Signatário
            </h5>
            <button type="button" className="close" data-dismiss="modal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div
              style={{ borderBottom: "1px solid #dee2e6", marginBottom: 10 }}
            >
              <p style={customStyles.labelInfo}>
                {" "}
                <strong>Nome: </strong> {nome}{" "}
              </p>
              <p style={customStyles.labelInfo}>
                <strong>CPF: </strong> {cpfCnpj}
              </p>
              <p style={customStyles.labelInfo}>
                <strong>Data Nascimento: </strong> {dataNasc}
              </p>
              <p style={customStyles.labelInfo}>
                <strong>Email: </strong> {email}
              </p>
              <p style={customStyles.labelInfo}>
                <strong>Celular: </strong> {celular}
              </p>
            </div>
            <div>
              <p style={customStyles.labelInfo}>
                <strong>Status:</strong>{" "}
                <span className={`badge badge-pill badge-${tipoStyle}`}>
                  {status}
                </span>
              </p>
              <p style={customStyles.labelInfo}>
                <strong>Assinado: </strong>{" "}
                {(status || "").toLowerCase().search(/assinado|finalizado/gi) >
                -1
                  ? "Sim"
                  : "Não"}
              </p>
              <p style={customStyles.labelInfo}>
                <strong>Tipo: </strong> {tipo}
              </p>
              <p style={customStyles.labelInfo}>
                <strong>Selfie: </strong>{" "}
                {selfieNecessaria === "S" ? "Sim" : "Não"}
              </p>
              <p style={customStyles.labelInfo}>
                <strong>Notificado por: </strong> {tipoNotificacao}
              </p>
              <p style={customStyles.labelInfo}>
                <strong>Validação da Biometria Facial (SERPRO): </strong>{" "}
                {realizarValidacaoFacial === "S" ? "Sim" : "Não"}
              </p>
              <p style={{ ...customStyles.labelInfo, marginBottom: 5 }}>
                <strong>Mensagem: </strong>
              </p>
              <textarea
                style={{
                  width: "100%",
                  borderRadius: 5,
                  padding: 5,
                  borderColor: "#e9ecef",
                }}
                disabled
              >
                {mensagem}
              </textarea>
            </div>
          </div>
        </div>
      </div>
    );
  }

  tipo(tipo) {
    var modal = null;
    switch (tipo) {
      case "remove":
        modal = this.modalRm();
        break;
      case "infos":
        modal = this.modalInfos();
        break;
      default:
        modal = this.modalAdd();
        break;
    }

    return modal;
  }

  render() {
    return (
      <div
        className="modal fade"
        id="modalSignatario"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        {/* {this.props.tipo != 'remove'
                    ?this.modalAdd()
                    :this.modalRm()
                } */}
        {this.tipo(this.props.tipo)}
      </div>
    );
  }
}

const mapStateToProps = ({ documentos, auth, signatario }) => {
  return {
    auth,
    documentos,
    signatario,
  };
};
export default connect(mapStateToProps, {
  addSigDoc,
  select_doc,
  buscaDocumento,
  limpa_msgs,
  showInfoSignatario,
  contatarSignatario,
  getTypesSig,
})(ModalSignatario);

const customStyles = {
  modal: {
    width: "50%",
    zIndex: "99999",
  },
  modalDialog: {
    margin: 0,
    padding: 0,
    maxWidth: "100%",
    width: "100%",
    height: "100%",
  },
  contentModal: {
    border: 0,
  },
  labelInfo: {
    //textTransform:'capitalize'
  },
};
